<!-- for testing -->
<!--<button *ngIf="userInfo.loggedIn" (click)="expireSession()" style="position: fixed; top: 0; right: 0;">Expire session</button>-->

<div #loginModal id="login-modal" class="ui tiny modal">

  <div class="content">
    <app-login-form [authExpired]="true"></app-login-form>
  </div>

</div>
